import { Component } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { TranslateModule } from '@ngx-translate/core';
import { Router, RouterModule } from '@angular/router';
import { MatIconModule } from '@angular/material/icon';
import { MatDividerModule } from '@angular/material/divider';
import { SharedService } from '../../../../shared/services/shared.service';
import { environment } from '../../../../../environments/environment';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { CommonModule } from '@angular/common';
import {
  ManagementContractNoticeAndAnnouncementFilterRequest,
	ManagementContractNoticeAndAnnouncementResponse,
	PublicContractNoticeControllerService,
	SimplifiedContractNoticeAndAnnouncementFilterRequest,
} from 'api-contract-notices';
import { Constants } from '../../../../shared/interfaces/constants';
import { take } from 'rxjs/internal/operators/take';
import { MatCardModule } from '@angular/material/card';
import { UtilsService } from '../../../../shared/services/utils.service';
import { LandingBannerComponent } from '../landing-banner/landing-banner.component';
import { MatButtonModule } from '@angular/material/button';
import { LandingHorizontalCrawlerComponent } from '../landing-horizontal-crawler/landing-horizontal-crawler.component';

@Component({
	selector: 'app-landing-home',
	standalone: true,
	imports: [
		TranslateModule,
		RouterModule,
		MatIconModule,
		MatDividerModule,
		CommonModule,
		MatCardModule,
		LandingBannerComponent,
		MatButtonModule,
		LandingHorizontalCrawlerComponent,
	],
	templateUrl: './landing-home.component.html',
	styleUrl: './landing-home.component.scss',
})
export class LandingHomeComponent {
	resellerSettingsContext: any;
	data: any = [];
	assetsPath = '';
	mobileView = false;
	private readonly DAYS_RANGE = 10;
	private readonly DATE_RANGE_LIMITS = {
		dateFrom: new Date(new Date().setDate(new Date().getDate() - this.DAYS_RANGE)),
		dateTo: new Date(),
	};
	topListContractNotices: ManagementContractNoticeAndAnnouncementResponse[] = [];
	constructor(
		private responsive: BreakpointObserver,
		private sharedService: SharedService,
		public utils: UtilsService,
		private apiPublicContractNotice: PublicContractNoticeControllerService,
		private router: Router
	) {
		this.sharedService.resellerSettingsContext.pipe(takeUntilDestroyed()).subscribe({
			next: response => {
				this.resellerSettingsContext = response;
				this.resellerSettingsContext.reseller = environment.reseller;
				this.data = this.resellerSettingsContext.home.data;

				if (this.data[0].type === 'topList') {
					this.getContractNoticesTopList();
				}

				this.assetsPath = `${environment.reseller.assets}/images/`;
			},
		});

		this.responsive
			.observe([Breakpoints.XSmall, Breakpoints.Small])
			.pipe(takeUntilDestroyed())
			.subscribe(result => {
				this.mobileView = false;

				if (result.matches) {
					this.mobileView = true;
				}
			});
	}

	getDisplayFieldByDataType(fieldName: string, item: ManagementContractNoticeAndAnnouncementResponse) {
		if (fieldName === 'title') {
			if (item.noticeType) {
				return this.utils.getParameterByLanguageScript(item, 'contractSubject', true);
			} else if (item.announcementType) {
				return this.utils.getParameterByLanguageScript(item.contractNotice, 'contractSubject', true);
			}
		} else if (fieldName === 'publishedDate') {
			return this.utils.formatDate(item.publishedDate);
		} else if (fieldName === 'content') {
			if (item.noticeType) {
				return this.utils.getParameterByLanguageScript(item.contractAuthority, 'name', true);
			} else {
				return this.utils.getParameterByLanguageScript(item.contractNotice?.contractAuthority, 'name', true);
			}
		}
	}

	navigateToPage(routerLink: string) {
		this.router.navigate([routerLink]);
	}

	gotoLogin() {
		this.navigateToPage('/account/login');
	}

	private getContractNoticesTopList() {
		const today = new Date();

		const oneMonthAgo = new Date(today);
		oneMonthAgo.setMonth(today.getMonth() - 1);
		oneMonthAgo.setHours(0, 0, 0, 0);

		const endOfToday = new Date(today);
		endOfToday.setHours(23, 59, 59, 999);

		const filtersDto: SimplifiedContractNoticeAndAnnouncementFilterRequest = {
			publishedDateFrom: oneMonthAgo.getTime(),
			publishedDateTo: endOfToday.getTime(),
			types: Constants.CONTRACT_NOTICE_TYPES as Array<ManagementContractNoticeAndAnnouncementFilterRequest.TypesEnum>,
			forHome: true,
		};

		this.apiPublicContractNotice
			.getPublicFilteredContractNoticesAndAnnouncements(filtersDto, 0, 9)
			.pipe(take(1))
			.subscribe({
				next: response => {
					this.topListContractNotices = response.content || [];
				},
			});
	}
}
